module.exports = __webpack_public_path__ + "static/media/CREAM-FTM.6f19cf17.png";